<template>
    <div class="row offer-filter pad-top">
        <div class="col-12">
            <MultiSelect track-by="name" v-model="Storage.selectedOffer" :options="Storage.offers" :multiple="true"
                         :close-on-select="false" :clear-on-select="false" :hide-selected="false" :preserve-search="true"
                         :placeholder="$t('statistic.offers')" label="name" :searchable="true"
                         :disabled="disabled" ref="multiselect">
                <template slot="option" scope="props">
                    <div class="option__desc">
                        <span class="option__title">
                           {{ props.option.title }} ({{ props.option.name }}) <b v-if="Storage.developMode">({{ props.option.id }})</b>
                        </span>
                    </div>
                </template>
            </MultiSelect>
        </div>
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <button class="btn btn-info" @click="this.reset" :disabled="disabled"><i class="fa fa-trash"></i>
                        {{ $t('filters.reset') }}
                    </button>
                </div>
                <div class="col-6 action">
                    <button class="btn btn-success" @click="this.selectAll" :disabled="disabled"><i class="fa fa-reply-all"></i>
                        {{ $t('filters.select_all') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'
  import API from '../../api/API'
  import Helper from '../../api/Helper'

export default {
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    name: 'OfferFilter',
    components: {
      MultiSelect
    },
    mounted () {
      this.$root.$on('country_selected', () => {
        API.getOffers(Helper.getCountryList()).then(response => {
          Storage.offers = response.data
        })
      })
      this.$root.$on('filters_reset_all', () => {
        this.reset()
      })
      this.$refs.multiselect.$on('select', function () {
        this.search = ''
      })
    },
    data () {
      return {
        Storage: Storage,
        vm: null
      }
    },
    methods: {
      dispatchInputAction () {
        this.$root.$emit('offer_selected')
      },
      limitTextMessage (count) {
        return this.$t('filters.more_pre') + count + this.$t('filters.more_post')
      },
      selectAll () {
        Storage.selectedOffer = Storage.offers
        this.dispatchInputAction()
      },
      reset () {
        Storage.selectedOffer = []
        this.dispatchInputAction()
      }
    },
    beforeDestroy () {
      this.$root.$off('country_selected')
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// OfferFilter.vue?5236bc3a